import { Point, Stitch } from '../types/pattern';
import { generateId } from './generateId';

export const rotatePoint = (point: Point, center: Point, angle: number): Point => {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const dx = point.x - center.x;
  const dy = point.y - center.y;
  return {
    x: center.x + dx * cos - dy * sin,
    y: center.y + dx * sin + dy * cos,
  };
};

export const generateSymmetricStitches = (
  stitch: Stitch,
  center: Point,
  orientationCenter: Point,
  symmetryAxes: number
): Stitch[] => {
  if (symmetryAxes < 2) return [stitch];

  const stitches: Stitch[] = [];
  const step = (2 * Math.PI) / symmetryAxes;
  for (let i = 0; i < symmetryAxes; i++) {
    const rotationAngle = step * i;
    const rotatedPosition = rotatePoint(stitch.position, center, rotationAngle);
    const rotatedOrientationCenter = rotatePoint(orientationCenter, center, rotationAngle);
    const dx = rotatedOrientationCenter.x - rotatedPosition.x;
    const dy = rotatedOrientationCenter.y - rotatedPosition.y;
    const angle = Math.atan2(dy, dx) - Math.PI / 2;
    stitches.push({
      ...stitch,
      id: generateId(),
      position: rotatedPosition,
      angle,
      orientationAngle: angle,
    });
  }
  return stitches;
};
